const STORAGE_PREFIX = 'firebird_';

function key(name: string): string {
  return `${STORAGE_PREFIX}${name}`;
}

export function getStoredToken(): string | null {
  try {
    return localStorage.getItem(key('token'));
  } catch {
    return null;
  }
}

export function setStoredToken(token: string): void {
  try {
    localStorage.setItem(key('token'), token);
  } catch {
    // localStorage unavailable (SSR, incognito, etc.)
  }
}

export function clearStoredToken(): void {
  try {
    localStorage.removeItem(key('token'));
  } catch {
    // noop
  }
}

export function getStoredUser(): {
  id: string;
  email: string;
  name: string;
} | null {
  try {
    const raw = localStorage.getItem(key('user'));
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setStoredUser(user: {
  id: string;
  email: string;
  name: string;
}): void {
  try {
    localStorage.setItem(key('user'), JSON.stringify(user));
  } catch {
    // noop
  }
}

export function clearStorage(): void {
  clearStoredToken();
  try {
    localStorage.removeItem(key('user'));
  } catch {
    // noop
  }
}
